import $ from 'jquery';

class NavToggle {
  constructor(target) {
    this.target = $(target);
    this.subMenu = this.target.find('.navi-toggle-child');
    this.subMenuA = this.target.find('.navi-toggle-child a');
    this.naviParentA = this.target.find('.navi-parent-a');
    this.classNameOpen = 'navi-toggle-parent--open';
    this._setClick();
  }

  _setClick() {
    this.naviParentA.click(
      function () {
        this.target.toggleClass(this.classNameOpen);
        this.subMenu.slideToggle();
        return false;
      }.bind(this),
    );

    this.subMenuA.click(
      function () {
        this.target.toggleClass(this.classNameOpen);
        this.subMenu.slideToggle();
        // return false;
      }.bind(this),
    );
  }

  // _setSubmenu() {
  //   this.navSubBtn.click(
  //     function () {
  //       this.navSubBtn.toggleClass('header__menu__subBtn--open');
  //       this.navSubBtn.next().toggleClass('header__menu__subMenu--open');
  //     }.bind(this),
  //   );
  // }
}

(() => {
  const targets = document.querySelectorAll('.navi-toggle-parent');
  if (!targets.length) return;
  targets.forEach((item) => {
    new NavToggle(item);
  });
})();
